<div class="cart-totals">

  <div class="item level is-mobile">
    <div class="key">Subtotal</div>
    <div class="val">{{ checkout?.cart?.cart_amount_ex_tax | currency }}</div>
  </div>

  <div class="item level is-mobile" *ngIf="checkout?.discountSum">
    <div class="key">Discounts</div>
    <div class="val"><span>-</span> {{ checkout?.discountSum | currency }}</div>
  </div>

  <div class="item level is-mobile" *ngIf="checkout.consignments[0]?.available_shipping_options?.cost">
    <div class="key">Shipping</div>
    <div class="val"><span>+</span> {{ checkout.consignments[0]?.available_shipping_options?.cost | json }}</div>
  </div>

  <div class="item level is-mobile" *ngIf="checkout.tax_total">
    <div class="key">Taxes</div>
    <div class="val"> <span>+</span> {{ checkout.tax_total | currency }} </div>
  </div>

  <div class="item level is-mobile">
    <div class="key"> <strong>Estimated Total</strong></div>
    <div class="val">{{ checkout.grand_total+checkout.consignments[0]?.available_shipping_options?.cost | currency }}</div>
  </div>

</div>
